<script lang="ts">
    import { geolocStore } from "../../stores/geolocStore";
    import Icon from "../Icon/Icon.svelte";

    export let title: string;
    export let roomId: number;
    export let roomType: string;
    export let audioEnabled: boolean = false;
</script>

<div
    class="inline-flex mx-auto justify-center items-center bg-primary text-white py-2 px-4 rounded-lg shadow-md animate-pulse header mb-1 mt-2"
>
    <div class="flex items-center flex-wrap justify-center max-w-full">
        <div class="flex items-center flex-shrink-0 mr-3">
            <span class="font-semibold whitespace-nowrap">{roomId}</span>

            <div class="flex items-center gap-2 ml-2 flex-none">
                <span class="flex-none">
                    {#if roomType === "video"}
                        <Icon name="fa fa-camera" title="roomType video" />
                    {:else if roomType === "screensharing"}
                        <Icon name="fa fa-desktop" title="roomType screensharing" />
                    {:else}
                        <Icon name="fa fa-question" color="black" title="roomType unknown" />
                    {/if}
                </span>

                <span class="flex-none">
                    {#if audioEnabled}
                        <Icon name="fa fa-microphone" title="Microphone enabled"/>
                    {:else}
                        <Icon name="fa fa-microphone-slash" color="black" title="Microphone disabled" />
                    {/if}
                </span>
                <span class="flex-none">
                    {#if $geolocStore.status === "sending"}
                        <Icon
                            name="fa fa-location-arrow"
                            color="gray"
                            title="Geoloc sending"
                        />
                    {:else if $geolocStore.status === "success"}
                        <Icon
                            name="fa fa-location-arrow"
                            color="white"
                            title="Geoloc success"
                        />
                    {:else if $geolocStore.status === "idle"}
                        <Icon
                            name="fa fa-location-arrow"
                            color="black"
                            title="Geoloc idle"
                        />
                    {:else if $geolocStore.status === "error"}
                        <Icon
                            name="fa fa-location-arrow"
                            color="black"
                            title={$geolocStore.msg}
                        /> 
                    {/if}
                </span>
            </div>
        </div>

        <span class="text-center break-words">
            {title}
        </span>
    </div>
</div>

<style>
    .bg-primary {
        background-color: var(--primary);
    }

    span.break-words {
        word-break: break-word;
    }

    @media (max-width: 640px) {
        span.break-words {
            max-width: 100%;
        }
        .header {
            max-width: 90%;
        }
    }
</style>
